import { useState } from 'react'
import { Film, ImageIcon } from 'lucide-react'
import styles from './Widgets.module.css'

// A post's picture in a fixed box, so rows keep one height and titles stay in
// a line whether the picture loads, fails or never existed. A missing or
// broken picture shows a neutral tile with an image or a video icon.
export function Thumb({ src, kind, size = 'default' }) {
  // The URL that failed, so a new picture gets its own chance to load.
  const [failedSrc, setFailedSrc] = useState(null)
  const showImage = Boolean(src) && failedSrc !== src
  const Icon = kind === 'video' ? Film : ImageIcon
  return (
    <span className={styles.thumb} data-size={size} data-thumb={showImage ? 'image' : 'placeholder'} data-kind={kind || undefined} aria-hidden="true">
      {showImage ? (
        <img className={styles.thumbImage} src={src} alt="" loading="lazy" decoding="async" onError={() => setFailedSrc(src)} />
      ) : (
        <Icon className={styles.thumbIcon} aria-hidden="true" />
      )}
    </span>
  )
}
